import { Tag } from '@ps/isp-web-component-library';
import type {
  MultipleAvailableOpportunity,
  SingleAvailableOpportunity
} from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import {
  getIsMultipleOpportunity,
  getIsSingleOpportunity
} from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';
import { select } from '@swf/core/store';
import { Odds } from '@swf/sports/components';

import useHaveOddsChangedWithinDuration from '../../../../../../../../hooks/useHaveOddsChangedWithinDuration';
import useIsMultipleStartingPriceOpportunity from '../../../../../../../../hooks/useIsMultipleStartingPriceOpportunity';
import useOpportunityOddsChanges from '../../../../../../../../hooks/useOpportunityOddsChanges';
import StartingPriceToggle from '../StartingPriceToggle/StartingPriceToggle';

interface Props {
  opportunity: SingleAvailableOpportunity | MultipleAvailableOpportunity;
}

const OddsDisplay: React.FC<Props> = ({ opportunity }) => {
  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const { haveOddsChangedWithinDuration } = useHaveOddsChangedWithinDuration(opportunity);
  const { haveOddsChanged } = useOpportunityOddsChanges(opportunity);
  const isMultipleStartingPriceOpportunity = useIsMultipleStartingPriceOpportunity(opportunity);
  const shouldShowOddsChangeTracker =
    (hasAutoAcceptEnabled && haveOddsChangedWithinDuration) ||
    (haveOddsChanged && !hasAutoAcceptEnabled);

  const isSingle = getIsSingleOpportunity(opportunity);

  if (isSingle && opportunity.isStartingPriceOpportunity) {
    return <StartingPriceToggle opportunity={opportunity} />;
  }

  if (opportunity.winRunnerOdds) {
    if (
      (isSingle && !opportunity.isStartingPriceOpportunity) ||
      (getIsMultipleOpportunity(opportunity) && !isMultipleStartingPriceOpportunity)
    ) {
      return (
        <Tag variant={shouldShowOddsChangeTracker ? 'tracker--secondary' : 'tracker--primary'}>
          <Odds {...opportunity.winRunnerOdds} />
        </Tag>
      );
    }
  }

  return null;
};

export default OddsDisplay;
